export default {"src":"/_next/static/media/euro-badge.d1679cbf.svg","height":127,"width":127,"blurWidth":0,"blurHeight":0};